import { Mapper } from "../../../../base/utils/mapper";

import { MenuModel }
from "../../../../domain/models/configuration/menu.model";

import { MenuEntity }
from "../entities/menu.entity";

export class MenuImplementationRepositoryMapper
extends Mapper<
MenuEntity,
MenuModel
> {

    mapFrom(param:
    MenuEntity):
    MenuModel {

        return {
            ...param
        };
    }

    mapTo(param:
    MenuModel):
    MenuEntity {

        return {
            ...param
        };
    }
}